"use client";

import { useFormatter, useTranslations } from "next-intl";
import { Link } from "@/i18n/navigation";
import { HOME_CONFIDENCE_METRICS } from "@/content/coverageMetrics";

export default function StatsSection() {
  const t = useTranslations("Stats");
  const format = useFormatter();
  return (
    <section id="platform-breadth" className="landing-metrics-band" aria-label={t("sectionLabel")}>
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <ul className="landing-metrics-grid">
          {HOME_CONFIDENCE_METRICS.map(({ key, value, href }) => (
            <li key={key} className="landing-metric-item" data-home-metric={key}>
              <Link href={href} className="landing-metric landing-metric-link"
                aria-labelledby={`metric-${key}-number metric-${key}-label metric-${key}-cta`}>
                <span id={`metric-${key}-number`} className="landing-metric-number">{format.number(value)}</span>
                <span className="landing-metric-accent" aria-hidden="true" />
                <span id={`metric-${key}-label`} className="landing-metric-label">{t(`${key}Label`)}</span>
                <span id={`metric-${key}-cta`} className="landing-metric-cta">{t(`${key}Link`)} <span aria-hidden="true">→</span></span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
